import { Component, Input } from '@angular/core';

@Component({
    selector: 'ms-star-rating',
    templateUrl: 'star-rating.component.html',
    standalone: false,
})
export class StarRatingComponent {
    private readonly maxRating = 5;
    hasRating = false;

    @Input() set rating(value: number | undefined) {
        if (typeof value !== 'undefined') {
            this.starArray = new Array(value);
            this.emptyStarArray = new Array(this.maxRating - value);
            this.hasRating = true;
        }
    }

    starArray: number[] = [];
    emptyStarArray: number[] = [];
}
